import React, { memo } from 'react';
import { TableRow, TableCell, Box, Typography, Chip } from '@mui/material';
import { reportStyles, reportCommonStyles } from '../shared/globalSX';
import AssigneeAvatarStack from '../shared/AssigneeAvatarStack';
import { useTranslation } from 'react-i18next';
import OverflowTooltip from '../shared/OverflowTooltip';
import { getStatusLabel } from '../shared/utils/status';

const TicketRow = memo(({ ticket, showDueDate = false }) => {
  const { t } = useTranslation();
  const dueDateValue = ticket?.due_date ? new Date(ticket.due_date).toLocaleDateString() : '-';
  const titleCellWidth = showDueDate ? { width: '40%' } : reportCommonStyles.tableCellWidth50;
  const assigneeCellWidth = showDueDate ? { width: '20%' } : reportCommonStyles.tableCellWidth25;
  const dueDateCellWidth = showDueDate ? { width: '15%' } : {};
  const statusCellWidth = showDueDate ? { width: '12.5%' } : reportCommonStyles.tableCellWidth17;
  const priorityCellWidth = showDueDate ? { width: '12.5%' } : reportCommonStyles.tableCellWidth18;

  return (
    <TableRow
      hover
      onClick={() => window.open(`/task/${ticket.ticket_number_prefix}-${ticket.ticket_number}`, '_blank')}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell sx={{ ...titleCellWidth, maxWidth: '200px' }}>
        <Box sx={{ width: '100%' }}>
          <OverflowTooltip 
            title={ticket.title} 
            maxLines={2} 
            sx={{ fontSize: '15px', fontWeight: 500 }}
          >
            {ticket.title}
          </OverflowTooltip>
          <Typography variant="caption" sx={reportStyles.captionText}>
            {ticket.ticket_number_prefix}-{ticket.ticket_number}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={assigneeCellWidth}>
        {(!ticket.assignees?.length && !ticket.assignee_name && !ticket.assignee) ? (
          <Typography variant="body2" sx={{ ...reportStyles.fontSize11, color: 'text.secondary', fontStyle: 'italic' }}>
            {t('dashboard.unassigned')}
          </Typography>
        ) : (
          <Box sx={{ width: 'fit-content' }}>
            <AssigneeAvatarStack assignees={ticket.assignees} assignee={ticket.assignee_name || ticket.assignee} />
          </Box>
        )}
      </TableCell>
      {showDueDate ? (
        <TableCell sx={dueDateCellWidth}>
          <Typography variant="body2" sx={reportStyles.fontSize11}>
            {dueDateValue}
          </Typography>
        </TableCell>
      ) : null}
      <TableCell sx={statusCellWidth}>
        <Chip label={getStatusLabel(ticket.status)} size="small" sx={reportStyles.fontSize11} />
      </TableCell>
      <TableCell sx={priorityCellWidth}>
        <Chip
          label={typeof ticket.priority === 'object' ? ticket.priority.name : ticket.priority}
          size="small"
          sx={reportStyles.fontSize11}
        />
      </TableCell>
    </TableRow>
  );
});

export default TicketRow;
